var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDog404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dog_404"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_404",
    "data-name": 404,
    className: "cls-2",
    d: "M90,11.22C101.62,29.12,83.2,57.89,71.08,71A89.62,89.62,0,0,1,36,94.16c-5.65,2-26.75,8.1-29.24-1.31-.81-3,5.65-7.14,7.81-8.6C45.5,63.36,46.83,5.77,70.78,2.31,78.22,1.23,86.3,5.6,90,11.22Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog404);
export default __webpack_public_path__ + "static/media/dog_404.ca26eb875dc98f94bf211e68970c200c.svg";
export { ForwardRef as ReactComponent };